import { Button } from '@atoms/Button';
import { Typography } from '@atoms/Typography';
import { Dialog as MuiDialog, Stack as MuiStack } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { IConfirmDialog } from './ConfirmDialog.types';

export default function ConfirmDialog({
  open,
  title,
  description,
  confirmBtnTitle,
  closeBtnTitle,
  callback,
  onClose,
}: IConfirmDialog) {
  const { t } = useTranslation();

  const handleConfirm = () => {
    if (callback) callback();
    // if (onClose) onClose();
  };

  return (
    <MuiDialog open={Boolean(open)} onClose={onClose}>
      <MuiStack
        sx={{
          py: 5,
          px: 3,
          minWidth: '396px',
        }}
        gap={2}
      >
        <MuiStack>
          <Typography variant="subtitle1">{title}</Typography>
          <Typography>{description}</Typography>
        </MuiStack>
        <MuiStack
          direction="row"
          gap={1}
          alignItems="center"
          justifyContent="flex-end"
        >
          <Button variant="contained" color="error" onClick={onClose}>
            {closeBtnTitle ?? t('취소')}
          </Button>
          <Button variant="contained" color="success" onClick={handleConfirm}>
            {confirmBtnTitle ?? t('확인')}
          </Button>
        </MuiStack>
      </MuiStack>
    </MuiDialog>
  );
}
